export const ERROR = "@LOGIN/ERROR";
export const SUCCESS = "@LOGIN/SUCCESS";
export const LOGIN = "@LOGIN/LOGIN";
export const LOGOUT = "@LOGIN/LOGOUT";
export const RESET_PASSWORD = "@LOGIN/RESET_PASSWORD";
